export type BlogCategory = "algorithm" | "system-design" | "behavioral" | "general";

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  content: string;
  excerpt: string;
  category: BlogCategory;
  author: string;
  authorPhoto?: string;
  coverImage?: string;
  published: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BlogComment {
  id: string;
  postId: string;
  author: string;
  authorPhoto?: string;
  content: string;
  createdAt: string;
}

export const CATEGORY_META: Record<BlogCategory, { label: string; color: string }> = {
  algorithm: { label: "Algorithms", color: "emerald" },
  "system-design": { label: "System Design", color: "blue" },
  behavioral: { label: "Behavioral", color: "purple" },
  general: { label: "General", color: "gray" },
};
